import {
  getRepriceApi,
  getPurchaseApi,
  getTripConfirmationApi,
  cancelTripApi,
} from '../../services/api/payment.service';
// eslint-disable-next-line import/no-named-as-default
import produce from 'immer';
import * as RootNavigation from '../../utils/navigationRef';
import { openAlert } from './alert';
import { getCreditCardVendor, getCreditCardVendorName } from '../../utils/creditcard.util';
import { selectAirSegments, selectTripSummary, selectTravelCart } from '../selectors/trip.selector';
import { selectSeatSelection } from '../selectors/seat.selector';
import {
  selectTripName,
  selectTripResults,
  selectSearchInput,
  selectChangeRes,
  selectIsRedisKeyPresent,
  selectHomepageUDIDvalues,
} from '../selectors/search.selector';
import { logException } from '../../utils/logger.utils';
import { selectAccessToken, selectCompanyCurrencyCulture } from '../selectors/auth.selector';
import { selectAirComponents } from '../selectors/air.selector';
import { selectTripKeySelected } from '../selectors/mytrips.selector';
import { Screens } from '../../constants/ScreenNames';
import i18n from 'i18next';
import { EVENTS_ENABLED, REBOOK_ENABLED } from '../../config/env';
import { selectTezEventDetails } from '../selectors/events.selector';
import { buildAirTravelComponentResponse } from '../../utils/air.util';
import { GetPlatformId } from '../../utils/common.utils';
import { Platform } from 'react-native';

export const SET_REPRICED_AIR_RESULTS = 'SET_REPRICED_AIR_RESULTS';
export const SET_REPRICED_AIR_ERROR = 'SET_REPRICED_AIR_ERROR';
export const SET_PURCHASED_TRIPKEY = 'SET_PURCHASED_TRIPKEY';
export const SET_RECEIPT = 'SET_RECEIPT';
export const SET_PAYMENT_IN_PROGRESS = 'SET_PAYMENT_IN_PROGRESS';
export const CANCEL_TRIP = 'CANCEL_TRIP';
export const UPDATE_TRIP_STATUS = 'UPDATE_TRIP_STATUS';
export const UPDATE_LEGS = 'UPDATE_LEGS ';
export const UPDATE_HOTEL_REVIEW = 'UPDATE_HOTEL_REVIEW';
export const setPaymentInProgress = (inProgress) => {
  return { type: SET_PAYMENT_IN_PROGRESS, inProgress };
};

export const updateAirLegs = (airLegs) => {
  return { type: UPDATE_LEGS, airLegs };
};
export const getReprice = (selectedAirCloud, passengers) => {
  return async (dispatch, getState) => {
    const hasAir = selectSearchInput(getState()).hasAir;
    if (hasAir) {
      const accessToken = selectAccessToken(getState());
      const tripsummary = selectTripSummary(getState());
      const travelRequestId = selectTripResults(getState()).TravelRequestId;
      const selectedAir = selectAirComponents(getState());
      if (tripsummary.AirResponses.length != 0) {
        let airResponseKeyLeg1 = '00000000-0000-0000-0000-000000000000';
        let multiBrandKeyLeg1 = '00000000-0000-0000-0000-000000000000';
        let airResponseKeyLeg2 = '00000000-0000-0000-0000-000000000000';
        let multiBrandKeyLeg2 = '00000000-0000-0000-0000-000000000000';
        let airResponseKeyLeg3 = '00000000-0000-0000-0000-000000000000';
        let multiBrandKeyLeg3 = '00000000-0000-0000-0000-000000000000';

        let airResponseKeyLeg4 = '00000000-0000-0000-0000-000000000000';
        let multiBrandKeyLeg4 = '00000000-0000-0000-0000-000000000000';
        let airResponseKeyLeg5 = '00000000-0000-0000-0000-000000000000';
        let multiBrandKeyLeg5 = '00000000-0000-0000-0000-000000000000';
        let airResponseKeyLeg6 = '00000000-0000-0000-0000-000000000000';
        let multiBrandKeyLeg6 = '00000000-0000-0000-0000-000000000000';

        if (selectedAir[1] != undefined) {
          airResponseKeyLeg1 = selectedAir[1]?.selectedAir?.ResponseID;
          multiBrandKeyLeg1 =
            selectedAir[1].newMultiBrandResponseKey != null
              ? selectedAir[1].newMultiBrandResponseKey
              : '00000000-0000-0000-0000-000000000000';
        }

        if (selectedAir[2] != undefined) {
          airResponseKeyLeg2 = selectedAir[2]?.selectedAir?.ResponseID;
          multiBrandKeyLeg2 =
            selectedAir[2].newMultiBrandResponseKey != null
              ? selectedAir[2].newMultiBrandResponseKey
              : '00000000-0000-0000-0000-000000000000';
        }

        if (selectedAir[3] != undefined) {
          airResponseKeyLeg3 = selectedAir[3]?.selectedAir?.ResponseID;
          multiBrandKeyLeg3 =
            selectedAir[3].newMultiBrandResponseKey != null
              ? selectedAir[3].newMultiBrandResponseKey
              : '00000000-0000-0000-0000-000000000000';
        }
        if (selectedAir[4] != undefined) {
          airResponseKeyLeg4 = selectedAir[4]?.selectedAir?.ResponseID;
          multiBrandKeyLeg4 =
            selectedAir[4].newMultiBrandResponseKey != null
              ? selectedAir[4].newMultiBrandResponseKey
              : '00000000-0000-0000-0000-000000000000';
        }
        if (selectedAir[5] != undefined) {
          airResponseKeyLeg5 = selectedAir[5]?.selectedAir?.ResponseID;
          multiBrandKeyLeg5 =
            selectedAir[5].newMultiBrandResponseKey != null
              ? selectedAir[5].newMultiBrandResponseKey
              : '00000000-0000-0000-0000-000000000000';
        }
        if (selectedAir[6] != undefined) {
          airResponseKeyLeg6 = selectedAir[6]?.selectedAir?.ResponseID;
          multiBrandKeyLeg6 =
            selectedAir[6].newMultiBrandResponseKey != null
              ? selectedAir[6].newMultiBrandResponseKey
              : '00000000-0000-0000-0000-000000000000';
        }

        const params = JSON.stringify({
          TripRequestKey: travelRequestId,
          AirResponseKeyLeg1: airResponseKeyLeg1,
          AirResponseKeyLeg2: airResponseKeyLeg2,
          AirResponseKeyLeg3: airResponseKeyLeg3,
          AirResponseKeyLeg4: airResponseKeyLeg4,
          AirResponseKeyLeg5: airResponseKeyLeg5,
          AirResponseKeyLeg6: airResponseKeyLeg6,
          MultiBrandKeyLeg1: multiBrandKeyLeg1,
          MultiBrandKeyLeg2: multiBrandKeyLeg2,
          MultiBrandKeyLeg3: multiBrandKeyLeg3,
          MultiBrandKeyLeg4: multiBrandKeyLeg4,
          MultiBrandKeyLeg5: multiBrandKeyLeg5,
          MultiBrandKeyLeg6: multiBrandKeyLeg6,
        });

        const reprice = await getRepriceApi(accessToken, params, selectedAirCloud, passengers);
        if (reprice.ErrorMessage == null) {
          dispatch({ type: SET_REPRICED_AIR_RESULTS, reprice });
          return true;
        } else {
          dispatch({ type: SET_REPRICED_AIR_ERROR, reprice });
          return false;
        }
      }
    }
    return true;
  };
};

export const getPurchase = (
  sponsoredCards,
  values,
  bNewAirCreditCard,
  bNewAirExtraCreditCard,
  bNewHotelCreditCard,
  bNewCarCreditCard,
  bNewRailCreditCard,
  countryList,
  selectedCar,
  policyExceptions,
  VirtualPaymentComponentTypes,
  formikHelpers
) => {
  return async (dispatch, getState) => {
    dispatch(setPaymentInProgress(true));
    const moment = require('moment');
    const accessToken = selectAccessToken(getState());
    const requestedComponents = selectTripResults(getState()).RequestedComponents;
    const tripSummary = selectTripSummary(getState());
    const changeResData = selectChangeRes(getState());
    const selectedEvent = selectTezEventDetails(getState());
    const isRedisKeyPresent = selectIsRedisKeyPresent(getState());
    const airComponents = selectAirComponents(getState());
    const searchInput = selectSearchInput(getState());
    const currencyCulture = selectCompanyCurrencyCulture(getState());
    const homepageUdidValues = selectHomepageUDIDvalues(getState());
    const cart = selectTravelCart(getState());
    const request = produce(selectTravelCart(getState()), (travelCart) => {
      const isAir = travelCart.IsAir;
      const isHotel = travelCart.IsHotel;
      const isCar = travelCart.IsCar;
      const isRail = travelCart.IsRail;
      const isAirExtra = travelCart.IsAirExtra;
      travelCart.Platform = GetPlatformId(Platform);
      travelCart.Culture = currencyCulture !== undefined ? currencyCulture : 'en-US';
      //0 is the default value for events flow
      const defaultCreditCardType = '0';
      const modifyCountryList = countryList.map(function (elm) {
        return { CountryName: elm['label'], CountryCode: elm['value'] };
      });

      if (isAir) {
        if (bNewAirCreditCard == true) {
          const modifyStateList = values.air.ccStateList.map(function (elm) {
            return { State: elm['label'], value: elm['value'] };
          });
          const countryName = modifyCountryList.find((obj) => {
            return obj.CountryCode === values.air.ccCountry;
          });

          let stateName = modifyStateList.find((obj) => {
            return obj.value === values.air.ccState;
          });

          if (stateName === undefined) {
            stateName = { State: 'None', value: 'NA' };
          }
          modifyStateList.unshift({ State: 'Select State', value: 'NA' });
          const selectedAirCreditcard = {
            BillingAddress: {},
            CreditCardType: 2,
            StateJson: modifyStateList,
          };
          selectedAirCreditcard.BillingAddress.CountryObj = countryName;
          selectedAirCreditcard.BillingAddress.StateObj = stateName;
          selectedAirCreditcard.BillingAddress.Line1 = values.air.ccBillingAddress;
          selectedAirCreditcard.BillingAddress.City = values.air.ccCity;
          selectedAirCreditcard.BillingAddress.Zip = values.air.ccZipCode;
          selectedAirCreditcard.BillingAddress.State = values.air.ccState;
          selectedAirCreditcard.BillingAddress.CountryName = countryName.CountryName;
          selectedAirCreditcard.BillingAddress.Country = values.air.ccCountry;

          selectedAirCreditcard.CreditCardType = values.air.ccType || defaultCreditCardType;
          selectedAirCreditcard.CreditCardVendorCode = values.air.ccProvider;
          selectedAirCreditcard.CreditCardCVVNumber = values.air.ccCVV;
          selectedAirCreditcard.isAir = true;
          selectedAirCreditcard.CreditCardDescription = values.air.ccName;
          selectedAirCreditcard.CreditCardNumber = parseInt(values.air.ccNumber);
          selectedAirCreditcard.CreditCardExpiryMonth = values.air.ccMonth;
          selectedAirCreditcard.CreditCardExpiryYear = values.air.ccYear;
          selectedAirCreditcard.BillingFirstName = values.air.ccFirstName;
          selectedAirCreditcard.CardHolderEmail = values.air.cardHolderEmail;
          // selectedAirCreditcard.CreditCardVendorCode = getCreditCardVendor(values.air.ccNumber);

          travelCart.SelectedAirCreditcard = { BillingAddress: {}, CreditCardType: 1 };
          travelCart.SelectedAirCreditcard = selectedAirCreditcard;
        } else {
          if (sponsoredCards?.isAirSponsoredTravel) {
            const selectedAirCreditcard = {
              CreditCardKey: sponsoredCards?.getDefaultAirCardKey,
            };
            const findAirCreditcard = travelCart.CreditCards.find((obj) => {
              return (
                obj.CreditCardKey === parseInt(selectedAirCreditcard.CreditCardKey) &&
                obj.isAir === isAir
              );
            });
            travelCart.SelectedAirCreditcard = findAirCreditcard;
          } else {
            const selectedAirCreditcard = { CreditCardKey: values.air.ccPreCreditCard };
            const findAirCreditcard = travelCart.CreditCards.find((obj) => {
              return (
                obj.CreditCardKey === parseInt(selectedAirCreditcard.CreditCardKey) &&
                obj.isAir === isAir
              );
            });

            travelCart.SelectedAirCreditcard = findAirCreditcard;
          }
        }

        const seatsSelected = selectSeatSelection(getState());
        const airSegments = selectAirSegments(getState());
        const purchasedSeats = [];
        Object.keys(seatsSelected).forEach(function (segmentId) {
          if (seatsSelected[segmentId] !== undefined) {
            const segment = airSegments.find((seg) => seg.SegmentId === segmentId);
            if (segment !== undefined) {
              purchasedSeats.push({
                FlightNumber: segment.FlightNumber,
                Price: seatsSelected[segmentId][0]?.Price || 0,
                SeatNumber: seatsSelected[segmentId][0]?.SeatNumber,
              });
            }
          }
        });
        if (purchasedSeats.length != 0) {
          travelCart.IsSeatSelected = true;
          travelCart.Passengers[0].SelectedSeats = purchasedSeats;

          if (bNewAirExtraCreditCard == true) {
            const modifyStateList = values.airExtra.ccStateList.map(function (elm) {
              return { State: elm['label'], value: elm['value'] };
            });
            const countryName = modifyCountryList.find((obj) => {
              return obj.CountryCode === values.airExtra.ccCountry;
            });

            let stateName = modifyStateList.find((obj) => {
              return obj.value === values.airExtra.ccState;
            });

            if (stateName === undefined) {
              stateName = { State: 'None', value: 'NA' };
            }
            modifyStateList.unshift({ State: 'Select State', value: 'NA' });
            const SelectedAirExtraCreditcard = {
              BillingAddress: {},
              CreditCardType: 2,
              StateJson: modifyStateList,
            };
            SelectedAirExtraCreditcard.BillingAddress.CountryObj = countryName;
            SelectedAirExtraCreditcard.BillingAddress.StateObj = stateName;
            SelectedAirExtraCreditcard.BillingAddress.Line1 = values.airExtra.ccBillingAddress;
            SelectedAirExtraCreditcard.BillingAddress.City = values.airExtra.ccCity;
            SelectedAirExtraCreditcard.BillingAddress.Zip = values.airExtra.ccZipCode;
            SelectedAirExtraCreditcard.BillingAddress.State = values.airExtra.ccState;
            SelectedAirExtraCreditcard.BillingAddress.CountryName = countryName.CountryName;
            SelectedAirExtraCreditcard.BillingAddress.Country = values.airExtra.ccCountry;

            SelectedAirExtraCreditcard.CreditCardType =
              values.airExtra.ccType || defaultCreditCardType;
            SelectedAirExtraCreditcard.CreditCardVendorCode = values.airExtra.ccProvider;
            SelectedAirExtraCreditcard.CreditCardCVVNumber = values.airExtra.ccCVV;
            SelectedAirExtraCreditcard.isAirExtra = true;
            SelectedAirExtraCreditcard.CreditCardDescription = values.airExtra.ccName;
            SelectedAirExtraCreditcard.CreditCardNumber = parseInt(values.airExtra.ccNumber);
            SelectedAirExtraCreditcard.CreditCardExpiryMonth = values.airExtra.ccMonth;
            SelectedAirExtraCreditcard.CreditCardExpiryYear = values.airExtra.ccYear;
            SelectedAirExtraCreditcard.BillingFirstName = values.airExtra.ccFirstName;
            // SelectedAirExtraCreditcard.CreditCardVendorCode = getCreditCardVendor(
            //   values.airExtra.ccNumber
            // );

            travelCart.SelectedAirExtraCreditcard = {
              BillingAddress: {},
              CreditCardType: 1,
            };
            travelCart.SelectedAirExtraCreditcard = SelectedAirExtraCreditcard;
          } else {
            if (sponsoredCards?.isAirExtraSponsoredTravel) {
              const SelectedAirExtraCreditcard = {
                CreditCardKey: sponsoredCards?.getDefaultAirExtraCardKey,
              };
              const findAirCreditcard = travelCart?.CreditCards?.find((obj) => {
                return (
                  obj.CreditCardKey === parseInt(SelectedAirExtraCreditcard?.CreditCardKey) &&
                  obj.isAirExtra === isAirExtra
                );
              });

              travelCart.SelectedAirExtraCreditcard = findAirCreditcard;
            } else {
              const SelectedAirExtraCreditcard = {
                CreditCardKey: values.airExtra.ccPreCreditCard,
              };
              const findAirCreditcard = travelCart?.CreditCards?.find((obj) => {
                return (
                  obj.CreditCardKey === parseInt(SelectedAirExtraCreditcard?.CreditCardKey) &&
                  obj.isAirExtra === isAirExtra
                );
              });

              travelCart.SelectedAirExtraCreditcard = findAirCreditcard;
            }
          }
        }
      }

      if (
        tripSummary?.ApprovalDetail?.IsRequestApproval ||
        tripSummary?.ApprovalDetail?.IsRequestNotification
      ) {
        travelCart.ApprovalDetail = {
          IsRequestApproval: tripSummary.ApprovalDetail.IsRequestApproval,
          ApprovalReasons: tripSummary.ApprovalDetail.ApprovalReasons,
          IsRequestNotification: tripSummary.ApprovalDetail.IsRequestNotification,
          NotificationReasons: tripSummary.ApprovalDetail.NotificationReasons,
        };
      }

      if (isHotel) {
        if (bNewHotelCreditCard == true) {
          const modifyStateList = values.hotel.ccStateList.map(function (elm) {
            return { State: elm['label'], value: elm['value'] };
          });
          const countryName = modifyCountryList.find((obj) => {
            return obj.CountryCode === values.hotel.ccCountry;
          });

          const stateName = modifyStateList.find((obj) => {
            return obj.value === values.hotel.ccState;
          });
          modifyStateList.unshift({ State: 'Select State', value: 'NA' });
          const selectedHotelCreditcard = {
            BillingAddress: {},
            CreditCardType: 2,
            StateJson: modifyStateList,
          };
          selectedHotelCreditcard.BillingAddress.CountryObj = countryName;
          selectedHotelCreditcard.BillingAddress.StateObj = stateName;
          selectedHotelCreditcard.BillingAddress.Line1 = values.hotel.ccBillingAddress;
          selectedHotelCreditcard.BillingAddress.City = values.hotel.ccCity;
          selectedHotelCreditcard.BillingAddress.Zip = values.hotel.ccZipCode;
          selectedHotelCreditcard.BillingAddress.State = values.hotel.ccState;
          selectedHotelCreditcard.BillingAddress.CountryName = countryName.CountryName;
          selectedHotelCreditcard.BillingAddress.Country = values.hotel.ccCountry;

          selectedHotelCreditcard.CreditCardType = values.hotel.ccType || defaultCreditCardType;
          selectedHotelCreditcard.CreditCardVendor = getCreditCardVendorName(travelCart, values);
          selectedHotelCreditcard.CreditCardVendorCode = values.hotel.ccProvider;

          selectedHotelCreditcard.isHotel = true;
          selectedHotelCreditcard.CreditCardDescription = values.hotel.ccName;
          selectedHotelCreditcard.CreditCardNumber = parseInt(values.hotel.ccNumber);
          selectedHotelCreditcard.CreditCardExpiryMonth = values.hotel.ccMonth;
          selectedHotelCreditcard.CreditCardExpiryYear = values.hotel.ccYear;
          selectedHotelCreditcard.BillingFirstName = values.hotel.ccFirstName;
          selectedHotelCreditcard.CardHolderEmail = values.hotel.cardHolderEmail;
          //selectedHotelCreditcard.CreditCardVendorCode = getCreditCardVendor(values.hotel.ccNumber);

          travelCart.selectedHotelCreditcard = { BillingAddress: {}, CreditCardType: 1 };
          travelCart.selectedHotelCreditcard = selectedHotelCreditcard;
        } else {
          if (sponsoredCards?.isHotelSponsoredTravel) {
            const selectedHotelCreditcard = {
              CreditCardKey: sponsoredCards?.getDefaultHotelCardKey,
            };
            const findHotelCreditcard = travelCart.CreditCards.find((obj) => {
              return (
                obj.CreditCardKey === parseInt(selectedHotelCreditcard.CreditCardKey) &&
                obj.isHotel === isHotel
              );
            });

            travelCart.SelectedHotelCreditcard = findHotelCreditcard;
          } else {
            const selectedHotelCreditcard = { CreditCardKey: values.hotel.ccPreCreditCard };
            const findHotelCreditcard = travelCart.CreditCards.find((obj) => {
              return (
                obj.CreditCardKey === parseInt(selectedHotelCreditcard.CreditCardKey) &&
                obj.isHotel === isHotel
              );
            });

            travelCart.SelectedHotelCreditcard = findHotelCreditcard;
          }
        }
      }

      if (isCar) {
        if (bNewCarCreditCard == true) {
          const modifyStateList = values.car.ccStateList.map(function (elm) {
            return { State: elm['label'], value: elm['value'] };
          });
          const countryName = modifyCountryList.find((obj) => {
            return obj.CountryCode === values.car.ccCountry;
          });

          const stateName = modifyStateList.find((obj) => {
            return obj.value === values.car.ccState;
          });
          modifyStateList.unshift({ State: 'Select State', value: 'NA' });
          const selectedCarCreditcard = {
            BillingAddress: {},
            CreditCardType: 2,
            StateJson: modifyStateList,
          };
          selectedCarCreditcard.BillingAddress.CountryObj = countryName;
          selectedCarCreditcard.BillingAddress.StateObj = stateName;
          selectedCarCreditcard.BillingAddress.Line1 = values.car.ccBillingAddress;
          selectedCarCreditcard.BillingAddress.City = values.car.ccCity;
          selectedCarCreditcard.BillingAddress.Zip = values.car.ccZipCode;
          selectedCarCreditcard.BillingAddress.State = values.car.ccState;
          selectedCarCreditcard.BillingAddress.CountryName = countryName.CountryName;
          selectedCarCreditcard.BillingAddress.Country = values.car.ccCountry;

          selectedCarCreditcard.CreditCardType = values.car.ccType || defaultCreditCardType;
          selectedCarCreditcard.CreditCardVendorCode = values.car.ccProvider;
          selectedCarCreditcard.CreditCardCVVNumber = values.car.ccCVV;
          selectedCarCreditcard.isCar = true;
          selectedCarCreditcard.CreditCardDescription = values.car.ccName;
          selectedCarCreditcard.CreditCardNumber = parseInt(values.car.ccNumber);
          selectedCarCreditcard.CreditCardExpiryMonth = values.car.ccMonth;
          selectedCarCreditcard.CreditCardExpiryYear = values.car.ccYear;
          selectedCarCreditcard.BillingFirstName = values.car.ccFirstName;
          selectedCarCreditcard.CreditCardName = values.car.ccFirstName;
          selectedCarCreditcard.CardHolderEmail = values.car.cardHolderEmail;
          //selectedCarCreditcard.CreditCardVendorCode = getCreditCardVendor(values.car.ccNumber);

          travelCart.selectedCarCreditcard = { BillingAddress: {}, CreditCardType: 1 };
          travelCart.selectedCarCreditcard = selectedCarCreditcard;
        } else {
          if (sponsoredCards?.isCarSponsoredTravel) {
            const selectedCarCreditcard = {
              CreditCardKey: sponsoredCards?.getDefaultCarCardKey,
            };
            const findCarCreditcard = travelCart.CreditCards.find((obj) => {
              return (
                obj.CreditCardKey === parseInt(selectedCarCreditcard.CreditCardKey) &&
                obj.isCar === isCar
              );
            });

            travelCart.SelectedCarCreditcard = findCarCreditcard;
          } else {
            const selectedCarCreditcard = { CreditCardKey: values.car.ccPreCreditCard };
            const findCarCreditcard = travelCart.CreditCards.find((obj) => {
              return (
                obj.CreditCardKey === parseInt(selectedCarCreditcard.CreditCardKey) &&
                obj.isCar === isCar
              );
            });

            travelCart.SelectedCarCreditcard = findCarCreditcard;
          }
        }
      }

      if (isRail) {
        if (bNewRailCreditCard == true) {
          const modifyStateList = values.rail.ccStateList.map(function (elm) {
            return { State: elm['label'], value: elm['value'] };
          });
          const countryName = modifyCountryList.find((obj) => {
            return obj.CountryCode === values.rail.ccCountry;
          });

          const stateName = modifyStateList.find((obj) => {
            return obj.value === values.rail.ccState;
          });
          modifyStateList.unshift({ State: 'Select State', value: 'NA' });
          const selectedRailCreditcard = {
            BillingAddress: {},
            CreditCardType: 2,
            StateJson: modifyStateList,
          };
          selectedRailCreditcard.BillingAddress.CountryObj = countryName;
          selectedRailCreditcard.BillingAddress.StateObj = stateName;
          selectedRailCreditcard.BillingAddress.Line1 = values.rail.ccBillingAddress;
          selectedRailCreditcard.BillingAddress.City = values.rail.ccCity;
          selectedRailCreditcard.BillingAddress.Zip = values.rail.ccZipCode;
          selectedRailCreditcard.BillingAddress.State = values.rail.ccState;
          selectedRailCreditcard.BillingAddress.CountryName = countryName.CountryName;
          selectedRailCreditcard.BillingAddress.Country = values.rail.ccCountry;

          selectedRailCreditcard.CreditCardType = values.rail.ccType || defaultCreditCardType;
          selectedRailCreditcard.CreditCardVendorCode = values.rail.ccProvider;

          selectedRailCreditcard.isRail = true;
          selectedRailCreditcard.CreditCardDescription = values.rail.ccName;
          selectedRailCreditcard.CreditCardNumber = parseInt(values.rail.ccNumber);
          selectedRailCreditcard.CreditCardExpiryMonth = values.rail.ccMonth;
          selectedRailCreditcard.CreditCardExpiryYear = values.rail.ccYear;
          selectedRailCreditcard.BillingFirstName = values.rail.ccFirstName;
          selectedRailCreditcard.CreditCardCVVNumber = values.rail.ccCVV;
          selectedRailCreditcard.CardHolderEmail = values.rail.cardHolderEmail;
          //selectedRailCreditcard.CreditCardVendorCode = getCreditCardVendor(values.rail.ccNumber);

          travelCart.selectedRailCreditcard = { BillingAddress: {}, CreditCardType: 1 };
          travelCart.selectedRailCreditcard = selectedRailCreditcard;
        } else {
          if (sponsoredCards?.isRailSponsoredTravel) {
            const selectedRailCreditcard = {
              CreditCardKey: sponsoredCards?.getDefaultRailCardKey,
            };
            const findRailCreditcard = travelCart.CreditCards.find((obj) => {
              return (
                obj.CreditCardKey === parseInt(selectedRailCreditcard.CreditCardKey) &&
                obj.isRail === isRail
              );
            });

            travelCart.SelectedCarCreditcard = findRailCreditcard;
          } else {
            const selectedRailCreditcard = { CreditCardKey: values.rail.ccPreCreditCard };
            const findRailCreditcard = travelCart.CreditCards.find((obj) => {
              return (
                obj.CreditCardKey === parseInt(selectedRailCreditcard.CreditCardKey) &&
                obj.isRail === isRail
              );
            });

            travelCart.SelectedCarCreditcard = findRailCreditcard;
          }
        }
      }
      travelCart.RequestedComponents = requestedComponents;
      travelCart.VirtualPaymentComponentTypes = VirtualPaymentComponentTypes;
      travelCart.HomepageOneWayUDIDsVals = homepageUdidValues;
      const passengers = travelCart.Passengers;
      const passengerCount = passengers.length;
      if (!REBOOK_ENABLED) {
        for (let i = 0; i < passengerCount; i++) {
          passengers[i].BirthDate = moment(passengers[i].BirthDate).format('MM-DD-YYYY');
          for (let j = 0; j < passengers[i].PassportDetails.length; j++) {
            if (passengers[i].PassportDetails[j].PassportDate == '0001-01-01T00:00:00') {
              passengers[i].PassportDetails[j].PassportDate = new Date();
            }
          }
        }
      }

      //selected AIR card

      //gender
      //travelCart.Passengers[0] =
      //billing address

      const Country = { CountryName: 'United States', CountryCode: 'US' };

      const tripName = selectTripName(getState());

      if (tripName) {
        travelCart.TripName = tripName;
      } else {
        travelCart.TripName = tripSummary.DestinationName + ' Trip';
      }
      if (changeResData) {
        const allLegs = changeResData?.AirResponseDetails?.AirLegs.map((airLeg) => {
          return ':' + airLeg.LegNumber;
        });
        travelCart.OldSelectedLegs = allLegs.join('');
        travelCart.OldTripId = changeResData?.TripId;
        travelCart.OldTicketNumber = changeResData?.TicketInfos[0];
      }
      travelCart.IsRedeem = false;
      travelCart.KnownTravellerCountry = { CountryObj: Country };
      travelCart.PassportCountry = { CountryObj: Country };

      travelCart.CashReward = null;
      travelCart.isPolicyAccepted = true;
      travelCart.UserToken = null;
      travelCart.IsSaveTrip = false;

      travelCart.IncludePriceInEmail = true; //there is a checkbox in passenger screen for this, but in old app it was being overriden here to always be true?

      //Policy reason codes selected
      const { airPolicyCode, carPolicyCode, hotelPolicyCode } = policyExceptions;
      travelCart.AirReasonCode = airPolicyCode;
      travelCart.CarReasonCode = carPolicyCode;
      travelCart.HotelReasonCode = hotelPolicyCode;
      travelCart.HotelInclusion.SelectedHotelUDIDOverNightStay =
        values.selectedHotelUDIDOverNightStay;

      if (EVENTS_ENABLED) {
        const event = {
          EventId: selectedEvent.eventMeeting?.CodeKey,
          MeetingCode: selectedEvent.eventMeeting?.Code,
          AttendeeGUID: selectedEvent.attendeeGUID,
        };
        travelCart.Event = event;
      }
    });
    let purchaseResponse;
    try {
      const selectionData = {};
      if (selectedCar && Object.keys(selectedCar).length > 0) {
        selectionData.selectedCar = selectedCar.Cardetail;
        if (isRedisKeyPresent) {
          const selectedAir = await buildAirTravelComponentResponse(
            airComponents,
            searchInput,
            null,
            cart.NdcData,
            cart.RepricedAirCost
          );
          selectionData.selectedAir = selectedAir;
          purchaseResponse = await getPurchaseApi(
            accessToken,
            encodeURIComponent(JSON.stringify(request)),
            selectionData
          );
        } else {
          purchaseResponse = await getPurchaseApi(
            accessToken,
            encodeURIComponent(JSON.stringify(request)),
            selectionData
          );
        }
      } else {
        if (isRedisKeyPresent) {
          const selectedAir = await buildAirTravelComponentResponse(
            airComponents,
            searchInput,
            null,
            cart.NdcData,
            cart.RepricedAirCost
          );
          selectionData.selectedAir = selectedAir;
          purchaseResponse = await getPurchaseApi(
            accessToken,
            encodeURIComponent(JSON.stringify(request)),
            selectionData
          );
        } else {
          purchaseResponse = await getPurchaseApi(
            accessToken,
            encodeURIComponent(JSON.stringify(request))
          );
        }
      }

      if (purchaseResponse.ok != undefined && !purchaseResponse.ok) {
        if (request?.IsRail) {
          throw new Error(purchaseResponse.Message);
        } else {
          throw new Error(purchaseResponse.statusText);
        }
      }

      dispatch({ type: SET_PURCHASED_TRIPKEY, purchaseResponse });
      dispatch(setPaymentInProgress(false));
      if (changeResData) {
        if (purchaseResponse?.ExchangePriceRQError) {
          dispatch(
            openAlert({
              message: purchaseResponse?.ExchangePriceRQError,
            })
          );
        }
        RootNavigation.navigate(Screens.TripHub, {
          tripKey: changeResData.TripId,
          showInvoiceFirst: true,
          travelRequestId: purchaseResponse[0]?.TravelRequestId,
        });
      } else {
        RootNavigation.navigate(Screens.Receipt, {
          tripKey: purchaseResponse[0].TripKey,
          showInvoiceFirst: true,
          travelRequestId: purchaseResponse[0]?.TravelRequestId,
        });
      }
    } catch (ex) {
      __DEV__ && console.log('purchase exc: ', ex);
      dispatch(setPaymentInProgress(false));
      let msg =
        'Please reselect your itinerary - something failed to process or your itinerary may not be available.';
      // Check if purchaseResponse.errorText is not null, undefined, or an empty string
      if (purchaseResponse?.errorText && purchaseResponse.errorText.trim()) {
        msg = purchaseResponse.errorText;
      } else {
        if (request?.IsRail) {
          if (ex.message.includes('FQTVNumber')) {
            msg = 'Invalid Loyalty Number';
          } else {
            msg = ex.message;
          }
        }
      }
      formikHelpers.setSubmitting(false);
      dispatch(
        openAlert({
          message: msg,
        })
      );
      logException(ex, { metaData: { TripRequestKey: request.TripRequestKey } });
    }
  };
};
export const getTripConfirmation = (tripKey, travelRequestId) => {
  return async (dispatch, getState) => {
    const accessToken = selectAccessToken(getState());
    let _tripKey = tripKey;
    if (!tripKey) {
      _tripKey = selectTripKeySelected(getState());
    }
    const receiptResponse = await getTripConfirmationApi(accessToken, _tripKey, travelRequestId);
    dispatch({ type: SET_RECEIPT, receiptResponse });
  };
};

export const cancelTrip = () => {
  return async (dispatch, getState) => {
    const accessToken = selectAccessToken(getState());
    const state = getState();
    const tripDetails = state.payment.receiptResponse;
    console.log(tripDetails);
    let msg;

    const modifiedResponse = tripDetails
      ?.map((res) => {
        let data = {};
        const pax = res.Passengers?.map((passenger) => {
          data = {
            PNR: res.PNR,
            TripId: res.TripId,
            TravelReqId: res.RequestId,
            SsSouthWestOrFrontier:
              res.IsAirExists &&
              (res.AirResponseDetails?.AirlineName.toLowerCase().includes('southwest') ||
                res.AirResponseDetails?.AirlineName.toLowerCase().includes('frontier'))
                ? true
                : false,
            OnlyAir:
              res.IsAirExists && !res.IsCarExists && !res.IsHotelExists && !res.IsRailExists
                ? true
                : false,
            IsRedeemSearch: false,
            UserKey: passenger.Id,
            AddtoQueu: true,
            IsHotelExists: res.IsHotelExists,
            IsRail: res.IsRailExists,
            IsVoucher: false,
            //RailManageAfterSalesRS: 'RailManageAfterSalesRS',
            Email: passenger.EmailAddress,
            //AmtrakPNR: 'amtrakPNR',
          };
          return data;
        });
        return pax;
      })
      .flat();

    console.log(modifiedResponse);

    const cancelResponse = await cancelTripApi(accessToken, JSON.stringify(modifiedResponse));
    if (cancelResponse[0].IsCancelled) {
      const tripStatus = 'PendingCancel';
      dispatch({ type: UPDATE_TRIP_STATUS, tripStatus });
      msg = i18n.t('tripHub:InvoiceSummary.SuccessfullyCancelledTheTrip');
      dispatch(
        openAlert({
          message: msg,
        })
      );
    } else {
      msg = i18n.t('tripHub:InvoiceSummary.CouldNotCancelTheTrip');
      dispatch(
        openAlert({
          message: msg,
        })
      );
    }
    dispatch({ type: CANCEL_TRIP });
  };
};

export const updateHotelReview = (HotelReview) => {
  return { type: UPDATE_HOTEL_REVIEW, HotelReview };
};
